import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { useResponsive } from 'src/hooks/useResponsive';
import { OrderScenario } from 'components/order/model/Order';

const PREFIX = 'ServiceNotAvailable';

const classes = {
    icon: `${PREFIX}icon`
};

const StyledBox = styled(Box, {
    shouldForwardProp: prop => prop !== 'isDesktop'
})<{ isDesktop: boolean }>(({ theme, isDesktop }) => ({
    display: 'flex',
    padding: theme.spacing(1.5),
    border: `1px solid ${theme.palette.primary.main}`,
    margin: isDesktop ? theme.spacing(1.5, 0, 2) : theme.spacing(1.5),
    flexShrink: 0,
    width: '100%',
    [`& .${classes.icon}`]: {
        color: theme.palette.primary.main,
        marginRight: theme.spacing(1)
    }
}));

interface IProps {
    scenario: OrderScenario;
}

export const ServiceNotAvailable: React.FC<React.PropsWithChildren<IProps>> = ({ scenario }) => {
    const { isDesktop } = useResponsive();

    const { t } = useTranslation();
    const scenarioErrorString = React.useMemo(() => {
        switch (scenario) {
            case OrderScenario.ORDER_TO_TABLE:
                return t('ERROR_LOCATION_OTT_DISABLED');
            case OrderScenario.TABLE:
                return t('ERROR_LOCATION_PAT_DISABLED');
            case OrderScenario.DINE_IN:
                return t('ERROR_LOCATION_DINE_IN_DISABLED');
            case OrderScenario.PREORDER:
            default:
                return t('ERROR_LOCATION_PRE_ORDER_DISABLED');
        }
    }, [scenario, t]);
    return (
        <StyledBox isDesktop={isDesktop}>
            <Typography>{scenarioErrorString}</Typography>
        </StyledBox>
    );
};
